import PlayBox from "./PlayBox";
import Thumbnail from "./Thumbnails";
import CheckOutWrapper from "./stripe/CheckOutWrapper";
import { Songcard } from "@/types";
import {
  Box,
  Center,
  Heading,
  Modal,
  ModalBody,
  ModalContent,
  ModalOverlay,
  useColorMode,
} from "@chakra-ui/react";
import { Dispatch, SetStateAction } from "react";
import { AiOutlineClose, AiOutlineShopping } from "react-icons/ai";

interface ModalCardProps {
  card: Songcard;
  price: boolean;
  showOpen: boolean;
  setModalOpen: Dispatch<SetStateAction<boolean>>;
}

export default function ThisIsModal({
  card,
  setModalOpen,
  showOpen,
}: ModalCardProps) {
  const { colorMode } = useColorMode();
  const backgroundColor = colorMode === "light" ? "white" : "black";

  return (
    <>
      <Center cursor={"pointer"} onClick={() => setModalOpen(true)}>
        <AiOutlineShopping size={25} />
      </Center>
      <Modal
        isOpen={showOpen}
        onClose={() => setModalOpen(false)}
        motionPreset="slideInBottom"
      >
        <ModalOverlay
          backdropInvert="80%"
          backdropFilter="blur(10px) hue-rotate(10deg)"
        />
        <ModalContent
          backgroundColor={backgroundColor}
          maxW={320}
          borderRadius={20}
        >
          <AiOutlineClose
            onClick={() => setModalOpen(false)}
            size={24}
            style={{ right: 15, top: 15, position: "absolute" }}
            cursor={"pointer"}
          />
          <ModalBody mb={0} mt={0} alignItems="center">
            {card.primary_artist && (
              <Heading mt={2} size={"md"}>
                This is {card.primary_artist.name}
              </Heading>
            )}
            <Center>
              <Box
                borderColor={colorMode === "dark" ? "white" : "black"}
                mb={3}
                mt={5}
              >
                <Thumbnail
                  ext_file={card.ext_file}
                  comp_file={card.comp_file}
                  image={card.image}
                />
              </Box>
            </Center>
            <PlayBox card={card} />
            <div style={{ marginTop: 10 }}>
              <CheckOutWrapper
                id={card.id}
                art={""}
                uuid={card.uuid}
                issued={""}
                price={2.99}
                image={""}
                ext_file={card.song.ext_file}
              />
            </div>
          </ModalBody>
        </ModalContent>
      </Modal>
    </>
  );
}
